import React from "react";
import _ from "lodash";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const Body = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { PR_data } = value;

          return (
            <div className="fk tc">
              <ul className="tc" style={{ listStyleType: "none" }}>
                {PR_data.map((el) => {
                  return (
                    <>
                      {el.display == "block" ? (
                        <>
                          {" "}
                          <li
                            className="fk"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span className="px-5">
                              {el.code}/{el.dp ? `${el.dp}/` : ""}{el.nrxdolar}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              /{el.dolar2}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              /{Number(el.nrxdolar * el.rezha).toFixed(2)}$/
                              {Number(el.rezha * 12).toFixed(0)}
                            </span>
                            <br />
                            <span>
                              {el.nrxdadarzan}ID/{el.nrxdinar}ID/
                              {Number(el.nrxdinar * el.rezha).toFixed(0)}ID/
                              {el.rezha}d
                            </span>
                          </li>
                        </>
                      ) : el.display == "inline" ? (
                        <>
                          {" "}
                          <li
                            className="fk"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>
                                {el.code}/{el.dp ? `${el.dp}/` : ""}{el.nrxdolar}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              /{el.dolar2}$
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              /{Number(el.nrxdolar * el.rezha).toFixed(2)}$/
                              {el.nrxdinar}ID/{el.nrxiwkarton}ID/
                              {el.nrxdadarzan}ID/
                              {el.rezha}d
                            </span>
                          </li>
                        </>
                      ) : el.display == "dolar" ? (
                        <>
                          {" "}
                          <li
                            className="fk d-flex justify-content-start"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>{el.name}/</span>
                            <span>
                                  {el.code}/{el.dp ? `${el.dp}/` : ""} {el.nrxdolar}
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                1
                              </sup>
                              $/{el.dolar2}
                              <sup
                                style={{
                                  fontSize: `${_.divide(el.font, 2)}px`,
                                  color: "black"
                                }}
                              >
                                2
                              </sup>
                              $/
                              {Number(el.nrxdolar * el.rezha).toFixed(2)}$/
                              {Number(el.rezha * 12).toFixed(0)}/ {el.rezha}d
                            </span>
                          </li>
                        </>
                      ) : el.display == "dinar" ? (
                        <>
                          {" "}
                          <li
                            className="fk d-flex justify-content-start"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                            <span>{el.name}/</span>
                            <span>
                                    {el.code}/{el.dp ? `${el.dp}/` : ""}{el.nrxdinar}ID/
                              {Number(el.nrxdinar * el.rezha).toFixed(0)}/
                              {Number(el.rezha * 12).toFixed(0)}/
                              {`${el.rezha}d`}
                            </span>
                          </li>
                        </>
                      ) : (
                        <>
                          {" "}
                          <li
                            className="fk"
                            style={{
                              fontSize: `${el.font}px`,
                              borderBottom: "2px solid black"
                            }}
                          >
                                    <div style={{ display: "inline-block" }}>
                                      <div style={{ fontSize: `${_.divide(el.font ? el.font : 25, 1)}px`, whiteSpace: "nowrap", lineHeight: "1" }}>
                                        {el.code}/{el.nrxdolar}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>1</sup>/<NumberFormat
                                          value={el.nrxdinar}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        />/ <NumberFormat
                                          value={el.dinar2}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        /><sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>2</sup>
                                      </div>
                                      <hr style={{
                                        borderBottom: "1px solid black",
                                        width: `${_.multiply(el.font ? el.font : 25, 10)}px`,
                                        margin: "0px"
                                      }}></hr>
                                      <div style={{ fontSize: `${_.divide(el.font ? el.font : 25, 1)}px`, whiteSpace: "nowrap", lineHeight: "1" }}>
                                        {el.rezha}d/ {el.dolar2}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>2</sup>/<NumberFormat
                                          value={el.nrxdadarzan}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        />/<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>p</sup>{el.dp || ""}<sup style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px`, color: "black" }}>d</sup>
                                        <span style={{ fontSize: `${_.divide(el.font ? el.font : 25, 2)}px` }}>/<NumberFormat

                                          value={el.singleSale}
                                          displayType={"text"}
                                          thousandSeparator={true}
                                        /></span>
                                      </div>
                                    </div>
                          </li>
                        </>
                      )}
                    </>
                  );
                })}
              </ul>
            </div>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default Body;
